<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              <router-link :to="{ name: 'configuracion-carta' }">
                {{ $t("configuracionCarta") }}</router-link
              >
            </li>
            <li
              class="breadcrumb-item active"
              aria-current="page"
              @click="contadorEasterEgg += 1"
            >
              {{ $t("menus") }} carta
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label for="listBusiness"
                  ><strong>{{ $t("negocio") }}</strong></label
                >
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="permisoCarta()"
                  :placeholder="this.$i18n.t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.establishmentName"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-5" v-if="listCartas.length > 1">
              <div class="form-group">
                <label
                  ><strong>{{ $t("cartaASecas") }}</strong></label
                >
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idCarta"
                  @change="getMenusCarta()"
                  filterable
                  :placeholder="$t('seleccionaUnaCarta')"
                >
                  <el-option
                    v-for="cart in listCartas"
                    class="select-primary"
                    :value="cart.id"
                    :label="cart.nombreMostrado"
                    :key="cart.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <canvas
        id="myCanvas"
        :width="this.ancho"
        :height="this.alto"
        style="border:1px solid #d3d3d3; display: none;"
      >
        Your browser does not support the HTML5 canvas tag.
      </canvas>
      <img :src="this.url" id="imagen" style="display: none;" />
      <!--TABLA DE GESTION DE CONFIGURACION DE CARTA-->
      <template v-if="permiso === 1"> </template>
      <template v-else-if="permiso && !esSelfi">
        <div class="col-md-7">
          <div class="form-group">
            <router-link
              :to="{
                name: 'menu-carta',
                params: { idBusiness: idBusiness, idCarta: idCarta },
              }"
            >
              <button class="btn btn-primary">
                <i class="fa fa-plus-square"></i>
                Añadir menú
              </button>
            </router-link>
            <!--<small class="ml-2"><i class="fas fa-info-circle" style="color: #07C7FF;"></i><span style="color: grey;"> Los menús son agrupaciones de productos por platos. Pueden ser personalizados por nombre y número máximo de platos a elegir.</span></small>-->
          </div>
        </div>

        <!--<div class="col-md-2">
          <div class="form-group">
            <el-select
              class="select-default"
              size="large"
              v-model="idTipo"
              filterable
              @change="getProductosCarta()"
              :placeholder="'Selecciona tipo de los productos'"
            >
              <el-option
                v-for="tipo in listTipoProducto"
                class="select-primary"
                :value="tipo.value"
                :label="tipo.label"
                :key="tipo.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>-->

        <div class="col-md-5 text-right">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-bind:placeholder="$t('buscar')"
              v-model="searchQuery"
              @keyup.enter.prevent="searchMenusCarta()"
            />
            <div class="input-group-append">
              <button
                class="btn btn-secondary"
                type="button"
                @click="searchMenusCarta"
              >
                <i class="fa fa-search"></i>
              </button>
              <button
                class="btn btn-secondary"
                type="button"
                @click="removeSearchMenusCarta()"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <template v-if="respuesta">
          <div class="col-md-12" v-for="cat in listMenusCarta" :key="cat.id">
            <p
              style="
                color: #1E22AA;
                margin: 10px 0px;
                font-size: 25px;
                font-family: 'Numier', 'Helvetica Neue', Arial;
                font-weight: bold;
              "
            >
              {{ cat.nombre }}
            </p>

            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th>{{ $t("imagen") }}</th>
                    <th v-if="activeCarta && listCartas.length > 1">
                      {{ $t("carta") }}
                    </th>
                    <th v-if="!idTipo">{{ $t("tipo") }}</th>
                    <th>{{ $t("nombre") }}</th>
                    <th>{{ $t("nombreEnTpv") }}</th>
                    <th class="text-center">{{ $t("precio") }}</th>
                    <th class="text-center" v-if="distinguirPrecios">
                      {{ $t("precio") + " " + $t("aDomicilio") }}
                    </th>
                    <th class="text-center">{{ $t("acciones") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="obj in cat.menus" :key="obj.id">
                    <td width="5%">
                      <div>
                        <template v-if="obj.imagen">
                          <img
                            @click="openModalEditar(obj)"
                            width="100%"
                            :src="obj.imagen + '?' + Date.now()"
                          />
                        </template>
                        <template v-else>
                          <img
                            @click="openModalEditar(obj)"
                            width="100%"
                            src="https://www.numier.com/cartadigital/no-products.png"
                          />
                        </template>
                      </div>
                    </td>
                    <td v-if="activeCarta && listCartas.length > 1">
                      <div>
                        {{ obj.nombreCarta }}
                      </div>
                    </td>
                    <td v-if="!idTipo">
                      <div>
                        <template v-if="obj.tipoCarta === 'C'">{{
                          $t("cartaASecas")
                        }}</template>
                        <template v-else-if="obj.tipoCarta === 'P'">{{
                          $t("pedido")
                        }}</template>
                        <template v-else>{{ $t("cartaYPedido") }}</template>
                      </div>
                    </td>

                    <td>
                      <div>
                        <span
                          v-bind:style="[
                            !obj.noDisponible
                              ? { 'text-decoration': 'line-through' }
                              : {},
                          ]"
                          >{{ obj.nombre }}</span
                        >
                        <span style="color: red" v-if="obj.baja">
                          [{{ $t("BAJA") }}]
                        </span>
                      </div>
                    </td>

                    <td>
                      <div>
                        <span
                          v-bind:style="[
                            !obj.noDisponible
                              ? { 'text-decoration': 'line-through' }
                              : {},
                          ]"
                          ><template v-if="obj.nombreProductoRef">{{ obj.nombreProductoRef }}</template><template v-else>Sin asociar</template></span
                        >
                      </div>
                    </td>
                    <td align="right">
                      <div>
                        <span
                          v-bind:style="[
                            !obj.noDisponible
                              ? { 'text-decoration': 'line-through' }
                              : {},
                          ]"
                          >{{ obj.precioTarifa1 | currency }}</span
                        >
                      </div>
                    </td>
                    <td v-if="distinguirPrecios" align="right">
                      <div>
                        <span
                          v-bind:style="[
                            !obj.noDisponible
                              ? { 'text-decoration': 'line-through' }
                              : {},
                          ]"
                          >{{ obj.precioTarifa1_d | currency }}</span
                        >
                      </div>
                    </td>
                    <td align="center">
                      <div
                        class="btn btn-link btn-xs"
                        :key="configcarta.toString()"
                        @click="abrirModalIdiomas(obj)"
                        v-if="configcarta.controlIdiomas"
                      >
                        <i class="fas fa-globe-americas" style="color: #1F51FF"></i>
                      </div>
                      <div class="btn btn-warning btn-link btn-xs">
                        <router-link
                          :to="{
                            name: 'menu-carta',
                            params: {
                              idBusiness: idBusiness,
                              idCarta: idCarta,
                              idMenu: obj.id,
                            },
                          }"
                        >
                          <i
                            style="color: orange"
                            v-tooltip.top-center="$i18n.t('editar')"
                            class="fas fa-pencil-alt"
                          ></i>
                        </router-link>
                      </div>
                      <div class="btn btn-danger btn-link btn-xs">
                        <el-checkbox
                          @change="changeNoDisponible(obj.id, obj.noDisponible)"
                          v-model="obj.noDisponible"
                        >
                          <template></template>
                          <strong
                            >{{
                              obj.noDisponible
                                ? $t("disponible")
                                : $t("noDisponible")
                            }}
                          </strong>
                        </el-checkbox>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
        <div class="alert alert-danger" style="width: 100%; margin-left: 1%; margin-right: 1%;" role="alert" v-else>
          No hay <b>menús</b> en este negocio.
        </div>
      </template>
      <template v-if="!permiso">
        <div class="col-md-12">
          <div class="alert alert-primary" align="center">
            <h3>
              <i class="fas fa-exclamation-circle"></i>
              {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
            </h3>

            <span>
              {{ $t("paraMasInformacionContacteConSu") }}
              <strong>{{ $t("distribuidor") }}</strong
              >.</span
            >
          </div>
        </div>
      </template>
    </div>

    <modal
      name="modalReply"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("replicarTodosLosProductos") }}</h4>
        </div>
        <div class="modal-body">
          <input
            type="checkbox"
            id="checkSelectAll"
            name="checkSelectAll"
            v-model="checkSelectAll"
            @click="selectAll"
          />
          <label for="checkSelectAll" class="checkSelectAll">{{
            $t("seleccionarTodos")
          }}</label>

          <div v-for="business in listBusinessReply">
            <el-checkbox
              v-if="business.id != idBusiness"
              v-model="business.checked"
              border
              class="checkbox-element"
              style="width: 100%"
            >
              {{ business.establishmentName }}
            </el-checkbox>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="$modal.hide('modalReply')">
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-primary" @click="modalConfirmation">
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>

    <modal
      :name="'editar-menu'"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("editarImagen") }}</h4>
        </div>

        <div class="modal-body">
          <template v-if="menuEditar.img">
            <p>
              <strong>{{ $t("imagen") }}</strong>
              <span style="color: red">*</span>
              <i
                class="fas fa-pencil-alt text-warning"
                @click="menuEditar.img = ''"
                v-tooltip.top-center="$t('editarImagen')"
              ></i>
            </p>
            <div style="width: 100%">
              <img
                width="100%"
                :src="menuEditar.img + '?' + menuEditar.updated"
              />
            </div>
          </template>
          <template v-else>
            <div class="form-group">
              <label
                ><strong>{{ $t("imagen") }}</strong>
              </label>
              <input
                class="form-control"
                type="file"
                style="height: 100px"
                @change="onFileChange"
              />
              <br />
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-default"
            @click="(img = ''), $modal.hide('editar-menu')"
          >
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-success" @click="editarImagen(menuEditar)">
            <i class="fa fa-check-circle"></i>
            {{ $t("guardar") }}
          </button>
        </div>
      </div>
    </modal>
    <modal
      :name="'anadir-idioma'"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            Traducir a Inglés: {{ menuEditar.nameProducto }}
          </h4>
        </div>

        <div class="modal-body">
          <div id="ingles">
            <label for="traduccion">Nombre: </label>
            <input
              id="traduccion"
              class="form-control"
              type="text"
              v-model="menuEditar.traduccion"
            />
            <label for="traduccion">Descripcion: </label>
            <input
              class="form-control"
              type="text"
              v-model="menuEditar.traduccionDesc"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-default"
            @click="(img = ''), $modal.hide('anadir-idioma')"
          >
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button
            class="btn btn-success"
            @click="cambiarIdiomaAProducto(menuEditar)"
          >
            <i class="fa fa-check-circle"></i>
            {{ $t("guardar") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

let p1,
  p2,
  p3,
  p4,
  p5 = null;
export default {
  name: "MenusCarta",

  created() {
    this.getBusiness();
    var image = new Image();
    image.src = this.url;
    this.alto = image.height;
    this.ancho = image.width;

    this.$store.dispatch("setNameRoute", "Productos carta");
  },
  data() {
    return {
      listTipoProducto: [
        {
          value: "",
          label: this.$t("todos"),
        },
        {
          value: "P",
          label: this.$t("pedidos"),
        },
        {
          value: "C",
          label: this.$t("cartaASecas"),
        },
      ],
      loading: null,
      idTipo: "",
      cacheImagen: 0,
      searchQuery: "",
      img: "",
      listMenusCarta: [],
      menuEditar: {},
      listBusinesses: [],
      idBusiness: 0,
      permiso: 1,
      nameRoute: "",
      logoNegocio: "",
      contadorEasterEgg: 0,
      descripcionCarta: "",
      tipoCarta: false,
      tipoPedido: false,
      activeCarta: false,
      listCartas: [],
      idCarta: 0,
      respuesta: false,
      preparadaCarta: false,

      alto: "",
      ancho: "",
      url: "",

      lang: "en",
      configcarta: {},

      //REPLY
      listBusinessReply: [],
      checkSelectAll: false,
      distinguirPrecios: false,
      loading: null,
    };
  },
  methods: {
    /**************************************************************************/

    /**
     * numiertpv --> idtpv=3308 , idbussines = 4
     * edu --> idtpv=15, idbussines =
     * coli --> idtpv=4475 ,   idbussines = 10
     * laloca --> idtpv=2942 ,
     *
     **/

    getCategoriesNumier() {
      var vm = this;
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      p3 = this.axios
        .get(this.$store.getters.apiUrl + "delivery/getCategoriesCarta", config)
        .then(function(responseProds) {
          vm.categoriesNumierList = responseProds.data.result;
          vm.catsDone = true;
        })
        .catch(function(error) {
          vm.loading.close();
          console.log(error);
        });
    },
    relacionarProductosYCategorias(listaProdNumier, forDelete) {
      var catProdList = [];
      var listaIdProd = [];
      var max = 0;
      var listaProdNum = JSON.parse(JSON.stringify(listaProdNumier));

      listaProdNum.forEach(function(prodNum, i) {
        if (prodNum.max_extra > max) {
          max = prodNum.max_extra;
        }

        var nextId = i + 1;
        var idCategoriaSelected = prodNum.idCategoria;
        listaIdProd.push(prodNum.id);
        if (
          nextId == listaProdNum.length ||
          idCategoriaSelected != listaProdNum[nextId].idCategoria
        ) {
          var jsonRel = {
            idCategoria: idCategoriaSelected,
            productsIdList: listaIdProd,
          };

          catProdList.push(jsonRel);

          listaIdProd = [];
        }
      });

      this.maxSelect = max;
      this.ProdCategoriRelationList = catProdList;
      this.relsDone = true;

      if (forDelete == "importandoCarta" && this.preparadaCarta == false) {
        
          this.prepararCarta();
      }
    },

    getSubProductosNumier(listaProdNumier) {
      var subProd = [];
      this.productSubproductList = [];

      if (!this.preparadaCarta) {
        this.getCategoriesNumier(); //P3


        this.loading.close();
        this.loading = Loading.service({
          text: this.$t("estamosEnEllo"),
        });

        Promise.all([p1, p2, p3, p4]).then(() => {
          listaProdNumier.forEach((prodNum) => {
            var config = {
              params: {
                idBusiness: this.idBusiness,
                jwt: this.$store.getters.jwt,
                idProduct: prodNum.id,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            var vm = this;
            this.axios
              .get(
                this.$store.getters.apiUrl +
                  "/products/getProductSubproductCarta",
                config
              )
              .then(function(responseSubproduct) {
                subProd = responseSubproduct.data;
                var prodSubProd = {
                  producto: prodNum,
                  subProd: subProd,
                };
                vm.productSubproductList.push(prodSubProd);
                //Comprobacion de si (prodNum) es el ultimo producto de (productsNumierList)
              })
              .catch(function(error) {
                console.log(error);
                vm.loading.close();
              });
          });
        });
      }
    },

    /**Helper delete from array */
    removeItemFromArr(arr, item) {
      var i = arr.indexOf(item);

      if (i !== -1) {
        arr.splice(i, 1);
      }
    },

    // No recoger 22
    // No domicilio 7
    cambiarIdiomaAProducto(obj) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusinessInfo: this.idCarta,
        producto: obj,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "cambiarIdiomaAProducto";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getMenusCarta();
            vm.$modal.hide("anadir-idioma");

            vm.img = "";

            let notify = vm.$t("editada");
            vm.$notify({
              message:
                vm.$t("imagen") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    abrirModalIdiomas(producto) {
      this.menuEditar = producto;
      this.$modal.show("anadir-idioma");
    },
    //REPLICADO
    getBusinessReplicado() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var vm = this;
      this.axios
        .get(
          vm.$store.getters.apiUrl + "general/getBusinessesByUserReplicado",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listBusinessReply = response.data.result;
            vm.$modal.show("modalReply");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getConfigDistinguirPrecios() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 55,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.distinguirPrecios = true;
          } else {
            vm.distinguirPrecios = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    openModalEditar(obj) {
      this.cacheImagen++;

      this.menuEditar = obj;

      this.$modal.show("editar-menu");

      //this.searchProducto(obj.nombreProductoRef);
    },

    getBusiness() {
      this.loading = Loading.service({ text: "Cargando..." });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.listBusinesses = response.data.result;

          vm.permisoCarta();
          vm.getConfigDistinguirPrecios();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    permisoCarta() {
      const selectedBusiness = this.listBusinesses.find(
        (business) => business.id == this.idBusiness
      );

      // Saber si es selfi o no
      if (selectedBusiness && selectedBusiness.selfi === "1") {
        this.esSelfi = true;
         swal({
          title: this.$t("nosmudamos"),
          text: this.$t("noscambiamosaselfi"), // Puedes traducir este texto si usas i18n
          confirmButtonClass: "btn btn-warning btn-fill",
          type: "warning",
        });
      } else {
        this.esSelfi = false;
        // console.log("no es selfi");
        this.getConfigDistinguirPrecios();

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          estado: this.estado,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getPermisoCarta", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listCartas = [
              {
                nombreMostrado: vm.$t("esteNegocioNoContieneNingunaCarta"),
                id: 0,
              },
            ];
            vm.idCarta = 0;

            if (response.data.result.permiso) {
              // console.log(response)
              vm.permiso = response.data.result.permiso;
              

              //vm.nameRoute = response.data.result.nameroute;
              //vm.logoNegocio = response.data.result.imagen;

              vm.listCartas = response.data.result.listCartas;

              response.data.result.listCartas.forEach(function(x) {

                if (x.noRecoger == true) {
                  vm.noRecoger = "1";
                } else {
                  vm.noRecoger = "0";
                }

                if (x.noDomicilio == true) {
                  vm.noDomicilio = "1";
                } else {
                  vm.noDomicilio = "0";
                }

              });
              vm.idCarta = response.data.result.listCartas[0].id;
              vm.descripcionCarta =
                response.data.result.listCartas[0].descripcionCarta;

              /*vm.noRecoger = response.data.result.listCartas[0].config.filter(
                (item) => item.idConfig == "22"
              )[0];
              vm.noDomicilio = response.data.result.listCartas[0].config.filter(
                (item) => item.idConfig == "7"
              )[0];*/
              vm.getMenusCarta();
            } else {
              vm.permiso = response.data.result.permiso;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
      }
    },

    searchMenusCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          query: this.searchQuery
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl +
            "delivery/searchMenusCarta",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.activeCarta = vm.searchQuery === "" ? false : true;

            vm.listMenusCarta = response.data.result;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    editarImagen(obj) {
      if (!obj.img) {
        obj.editImage = true;

        obj.img = this.img;
      }
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        menu: obj,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "editarImagenMenuCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getMenusCarta();
            vm.$modal.hide("editar-menu");

            vm.img = "";

            let notify = vm.$t("editada");
            vm.$notify({
              message:
                vm.$t("imagen") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    openModalFinDeProceso() {
      swal({
        title: this.$t("procesoCompletado"),
        text: this.$t("finProgres"),
        type: "success",
        showCancelButton: false,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("vale"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.reset();
        }
      });
    },

    openModalNoDisponible(id, baja) {
      this.changeNoDisponible(id, baja);
    },
    changeNoDisponible(id, baja) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        idMenu: id,
        baja: baja,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "updateDisponibleMenu";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getMenusCarta();

            let notify = vm.$t("editado");
            vm.$notify({
              message:
                "Menú" + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    getMenusCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          //idTipo: this.idTipo,
          idCarta: this.idCarta,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getMenusCarta", config)
        .then(function(response) {

          vm.loading.close();

          if (response.data.response) {
            vm.listMenusCarta = response.data.result;
            
            vm.respuesta = vm.listMenusCarta.length > 0 ? true : false;

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.img = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeSearchMenusCarta() {
      this.activeCarta = false;
      this.searchQuery = "";
      this.getMenusCarta();
    },

    modalConfirmation() {
      swal({
        title: this.$t(
          "estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados"
        ),
        text: this.$t("estaAccionNoSePuedeDeshacer"),
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siReplicar"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.replyProducts();
        }
      });
    },
    replyProducts() {
      var listBuinessReply = this.listBusinessReply.filter(
        (bussines) => bussines.checked
      );

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      var params = {
        idBusiness: this.idBusiness,
        listBusinesses: listBuinessReply,
        idCarta: this.idCarta,
        jwt: this.$store.getters.jwt,
      };
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/replyAllProducts",
          params,
          config
        )
        .then(function(response) {
          vm.$modal.hide("modalReply");

          // if (response.data.response) {
          //     vm.closeModal();
          // } else {
          //     swal({
          //         title: `Atención`,
          //         text: response.data.message,
          //         confirmButtonClass: 'btn btn-info btn-fill',
          //         type: 'error'
          //     });
          //
          //
          // }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    selectAll() {
      if (this.checkSelectAll) {
        this.listBusinesses.forEach(function(business) {
          business.checked = false;
        });
      } else {
        this.listBusinesses.forEach(function(business) {
          business.checked = true;
        });
      }
    },
  },

  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Option.name]: Option,
  },
};
</script>

<style scoped>
tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
  cursor: pointer;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

.card {
  padding: 20px;
}

.input-group button {
  height: 40px;
}

.botonTotal {
  border: 1px solid #28a745;
  color: #ffffff;
  background-color: #28a745;
  font-weight: 400;
  padding: 8px 16px;
  /* cursor: pointer; */
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 1.42857143;
}

.nombreProducto {
  color: #fff;
  background-color: #0e0e0e;
  text-shadow: 1px 1px #333;
  font-weight: 700;
  font-size: 15px;
}

.tituloPedido {
  color: #1E22AA;
  font-family: "Numier", "Helvetica Neue", Arial;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Menus/MenusCarta.vue